<template>
  <div
    class="in-view-observer"
    :class="viewStatusClass"
  >
    <slot />
  </div>
</template>
<script>
  import throttle from 'lodash.throttle'

  const STATUS = {
    ABOVE: 1,
    BELOW: 2,
    IN_VIEW: 3,
    IN_TO_VIEW: 4
  }

  export default {
    props: {
      active: {
        type: Boolean,
        default: true
      },
      threshold: {
        type: Number,
        default: 33
      },
      mdThreshold: {
        type: Number,
        default: null
      },
      thresholdType: {
        type: String,
        default: '%',
        validator: (val) => {
          return ['%','px'].indexOf(val) !== -1
        }
      },
      aboveClass: {
        type: String,
        default: 'is-above-view'
      },
      belowClass: {
        type: String,
        default: 'is-below-view'
      },
      inViewClass: {
        type: String,
        default: 'is-in-view'
      },
      inToViewClass: {
        type: String,
        default: 'is-in-to-view'
      },
      log: Boolean
    },
    data () {
      return {
        currentStatus: null
      }
    },
    computed: {
      viewStatusClass () {
        switch (this.currentStatus) {
          case STATUS.ABOVE:
            return this.aboveClass
          case STATUS.BELOW:
            return this.belowClass
          case STATUS.IN_VIEW:
            return this.inViewClass
          case STATUS.IN_TO_VIEW:
            return `${this.inViewClass} ${this.inToViewClass}`
          default:
            return ''
        }
      },
      currentThreshold () {
        if(this.mdThreshold && this.$root && this.$root.currentSizeLte('md')) {
          return this.mdThreshold
        }
        return this.threshold
      }
    },
    watch: {
      active (val) {
        if (val) {
          window.addEventListener("scroll", throttle(() => {
            this.checkView()
          }, 100))
        } else {
          window.removeEventListener("scroll", throttle(() => {
            this.checkView()
          }, 100))
        }
      }
    },
    beforeDestroy () {
      window.removeEventListener("scroll", throttle(() => {
        this.checkView()
      }, 100))
    },
    mounted () {
      // We skip in view when in epi (if in iframe) since the scroll listener wont work and blocks wont show.
      if (window === window.parent) {
        if (this.active) {
          window.addEventListener("scroll", throttle(() => {
            this.checkView()
          }, 100))
          this.checkView()
        }
      } else {
        this.currentStatus = STATUS.IN_VIEW
      }
    },
    methods: {
      checkView () {
        const windowHeight = window.innerHeight
        const elPos = this.$el.getBoundingClientRect()
        const thresholdPx = this.thresholdType === 'px' ? this.currentThreshold : elPos.height * this.currentThreshold / 100

        if (windowHeight - elPos.top > thresholdPx) {
          if (elPos.top + elPos.height < thresholdPx) {
            this.currentStatus = STATUS.ABOVE
          } else {
            if(0 > ((elPos.top + elPos.height) - windowHeight)) {
              this.currentStatus = STATUS.IN_VIEW
            } else {
              this.currentStatus = STATUS.IN_TO_VIEW
            }
          }
        } else {
          this.currentStatus = STATUS.BELOW
        }
      }
    }
  }
</script>
